import styles from './invictustest.module.css'

const WhyInvictus = () => {
    return (
        <div>
            {/*why invictus start*/}
            <section id="process" data-aos="fade-down" data-aos-duration="1000" className="container">
                <div className={`${styles.process__container}`}>
                    <div className={`${styles.sticky_header}`}>
                    </div>
                    <ul className={`${styles.cards_container}`}>
                        <li className={`${styles.card}`} style={{'--index': '1'}}>
                            <div className={`${styles.absolute_header}`}>
                                <div className={`${styles.invictus_heading}`}>
                                    <h3>Why Invictus?</h3>
                                    <p>
                                        Advanced JEE program for IITs, led by the most experienced faculty
                                    </p>
                                </div>
                            </div>
                            <div className={`${styles.card_body}`}>
                                <div className={`${styles.invictus_box1}`}>
                                    <div className={`${styles.in_content}`}>
                                        <h4>Access best <span className={`${styles.inv_span1}`}>prep content</span> across India</h4>
                                        <h6>Premium resources to help you excel in your JEE preparation.</h6>
                                    </div>
                                    <div className={`${styles.invictus_image1}`}>
                                        <img src="https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/bulb-invictus-image1.gif" alt="" />
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className={`${styles.card}`} style={{'--index' : '2'}}>
                            <div className={`${styles.card_body}`}>
                                <div className={`${styles.invictus_box2}`}>
                                    <div className={`${styles.in_content}`}>
                                        <h4>Best in class <span className={`${styles.inv_span2}`}>delivery platform</span></h4>
                                        <h6>Seamless & interactive learning experience.</h6>
                                    </div>
                                    <div className={`${styles.invictus_image2}`}>
                                        <img src="https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/High-Level_Goal-invictus.gif" alt="" />
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className={`${styles.card}`} style={{'--index': '3'}}>
                            <div className={`${styles.card_body}`}>
                                <div className={`${styles.invictus_box3}`}>
                                    <div className={`${styles.in_content}`}>
                                        <h4>AI-Powered <span className={`${styles.inv_span3}`}>personalised learning</span></h4>
                                        <h6>
                                            Personalized Learning with tailored study plans to boost your
                                            performance.
                                        </h6>
                                    </div>
                                    <div className={`${styles.invictus_image3}`}>
                                        <img src="https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/Robotics_Students-invictus.gif" alt="" />
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className={`${styles.empty_container}`}></div>
            </section>
            {/* why invictus end */}
        </div>
    )
}

export default WhyInvictus